/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserBrowserInfo} from '../models/UserBrowserInfo';

export interface GetUserBrowserInfo$Request {
    userId: number;
}

export interface GetUserBrowserInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserBrowserInfoRequest = createAction<PayloadData<void, GetUserBrowserInfo$Request>>('GET_USER_BROWSER_INFO__GET_USER_BROWSER_INFO__REQUEST');
export const getUserBrowserInfoSuccess = createAction<PayloadData<UserBrowserInfo, GetUserBrowserInfo$Request>>('GET_USER_BROWSER_INFO__GET_USER_BROWSER_INFO__SUCCESS');
export const getUserBrowserInfoFailure = createAction<PayloadData<Error, GetUserBrowserInfo$Request, true>>('GET_USER_BROWSER_INFO__GET_USER_BROWSER_INFO__FAILURE');

export const getUserBrowserInfoActions = [
    getUserBrowserInfoRequest,
    getUserBrowserInfoSuccess,
    getUserBrowserInfoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserBrowserInfo = (meta: GetUserBrowserInfo$Request, config?: GetUserBrowserInfo$Config) => {
    return {
        CALL_API: {
            types: getUserBrowserInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/browser-registration`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

